import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { ResidentPicker } from "@/components/nds/windows/resident/ResidentPicker";
import NotesTab from "@/components/nds/windows/resident/NotesTab";
import { OpenResidentButton } from "@/components/nds/OpenResidentButton";

export default function ReCaseNotesContent() {
  const [res, setRes] = useState(null);
  return (
    <div data-testid="re-notes-content" className="h-full overflow-y-auto p-5 space-y-4">
      {res ? (
        <>
          <button type="button" onClick={() => setRes(null)} data-testid="re-notes-back" className="inline-flex items-center gap-1 font-mono text-[10px] tracking-[0.22em] uppercase text-nex-gold"><ArrowLeft className="h-3.5 w-3.5" /> Residents</button>
          <div className="flex items-center gap-3"><h3 data-testid="re-notes-resident" className="text-lg font-semibold text-nex-silver">{res.first_name} {res.last_name}</h3><OpenResidentButton residentId={res.id} name={`${res.first_name} ${res.last_name}`} /></div>
          <NotesTab resident={res} manage />
        </>
      ) : <ResidentPicker prefKey="notes" onPick={setRes} testid="re-notes-picker" />}
    </div>
  );
}
